export const site = {
  nom: 'Zillenium Academy',
  logo: 'https://cdn.magicpatterns.com/uploads/ct2bVoKNRCJvff6fWqFLDW/download.png',
  heroImage:
    'https://cdn.magicpatterns.com/patterns/generated-images/f866af9b-806b-445a-9adc-51dbe9ffa697.jpg',
  imageApproche:
    'https://cdn.magicpatterns.com/patterns/generated-images/0f21792b-536f-479f-b627-8d04920c65d2.jpg',
  baseline:
    'Organisme de formation professionnelle certifié Qualiopi, à Joigny (Yonne).',
  email: 'administratif@zilleniumacademy.fr',
  telephone: '09 83 49 01 81',
  telephoneLien: '+33983490181',
  refHandicap: 'samir@zilleniumacademy.fr',
  adresse: '25 rue Gabriel Cortel, 89300 Joigny',
  ville: 'Joigny',
  departement: 'Yonne (89)',
  site: 'zilleniumacademy.fr',
  instagram: 'https://www.instagram.com/zillenium_academy',
  linktree: 'https://linktr.ee/zillenium.formation',
}

// Envoi réel du formulaire de contact.
// Le service FormSubmit transmet chaque demande par e-mail à l'adresse ci-dessous.
// IMPORTANT : à la toute première demande envoyée depuis le site publié, un e-mail
// d'activation est reçu sur cette boîte — il faut cliquer sur le lien pour activer l'envoi.
export const formEndpoint = `https://formsubmit.co/ajax/${site.email}`

// Passer à true pour afficher les tarifs publics sur le site
// (les montants restent renseignés dans data/formations.ts).
export const afficherTarifs = false

export const publics = [
  'Entreprises',
  'Dirigeants',
  'Commerçants',
  'Indépendants',
  'Salariés',
  'Managers',
  'Créateurs & porteurs de projet',
  'Associations',
]

export const raisons = [
  {
    titre: 'Un organisme certifié Qualiopi',
    texte:
      'La certification Qualiopi atteste de la qualité du processus mis en œuvre pour nos actions de formation professionnelle.',
  },
  {
    titre: 'Des formations ancrées dans le terrain',
    texte:
      'Digital, commerce, management, entrepreneuriat : nos parcours partent de situations professionnelles réelles, pas de théorie hors sol.',
  },
  {
    titre: 'Un ancrage local à Joigny',
    texte:
      'Basés dans l’Yonne, nous intervenons auprès des entreprises, commerces et associations du territoire, chez nous ou chez vous.',
  },
  {
    titre: 'Un besoin analysé avant toute inscription',
    texte:
      'Un échange préalable permet d’identifier vos objectifs, le profil des bénéficiaires et les éventuels besoins d’adaptation.',
  },
  {
    titre: 'Des modalités souples',
    texte:
      'Selon la formation : présentiel, distanciel ou format mixte, en individuel comme en groupe constitué.',
  },
  {
    titre: 'Une qualité suivie dans le temps',
    texte:
      'Les retours des bénéficiaires sont analysés afin d’ajuster les prestations lorsque cela est nécessaire.',
  },
]

export const methodes = [
  {
    titre: 'Apports structurés',
    texte:
      'Des apports théoriques courts et des démonstrations, pour donner le cadre sans noyer les participants.',
  },
  {
    titre: 'Ateliers et cas pratiques',
    texte:
      'Exercices, études de cas et travaux pratiques appliqués à votre activité, votre point de vente ou votre projet.',
  },
  {
    titre: 'Mises en situation',
    texte:
      'Simulations, jeux de rôle et échanges guidés pour ancrer les réflexes avant de les rejouer sur le terrain.',
  },
  {
    titre: 'Évaluation continue',
    texte:
      'Selon le parcours : positionnement, quiz, exercices, cas pratiques, mises en situation et évaluation finale.',
  },
]

export const parcours = [
  {
    titre: 'Analyse du besoin',
    texte:
      'Un échange préalable permet d’identifier les objectifs, le profil du bénéficiaire et les éventuels besoins d’adaptation.',
  },
  {
    titre: 'Inscription',
    texte:
      'L’inscription est validée après accord sur le programme, le devis et les documents contractuels.',
  },
  {
    titre: 'Déroulement de la formation',
    texte:
      'Selon la formation, le parcours peut être organisé en présentiel, en distanciel ou en format mixte.',
  },
  {
    titre: 'Évaluation & documents remis',
    texte:
      'Attestation de fin de formation ou de réalisation, émargements et questionnaire de satisfaction.',
  },
]

export const faq = [
  {
    question: 'Que signifie la certification Qualiopi ?',
    reponse:
      'Qualiopi atteste de la qualité du processus mis en œuvre par un organisme pour ses actions de formation. Zillenium Academy est certifié Qualiopi.',
  },
  {
    question: 'Quels sont les délais d’accès à une formation ?',
    reponse:
      'Nos formations démarrent 14 jours après validation de l’inscription. L’inscription est validée après accord sur le programme, le devis et les documents contractuels.',
  },
  {
    question: 'Y a-t-il des prérequis ?',
    reponse:
      'Aucun prérequis n’est demandé pour la majorité de nos formations. Une expérience professionnelle est souhaitée pour le parcours « Management commercial : encadrer et transmettre ».',
  },
  {
    question: 'Les formations ont-elles lieu en présentiel ou à distance ?',
    reponse:
      'Cela dépend du parcours. « Numériser son entreprise à l’ère du digital » se déroule en présentiel. Les trois autres formations peuvent être organisées en présentiel, en distanciel ou en format mixte selon l’organisation retenue.',
  },
  {
    question: 'Quel document est remis à l’issue de la formation ?',
    reponse:
      'Une attestation de fin de formation ou de réalisation, accompagnée des émargements et d’un questionnaire de satisfaction.',
  },
  {
    question: 'Je suis en situation de handicap : quelles adaptations sont possibles ?',
    reponse:
      'Zillenium Academy étudie les aménagements possibles en fonction des besoins du bénéficiaire. Contactez notre référent handicap avant l’inscription : samir@zilleniumacademy.fr.',
  },
]
